import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { LocaleType } from '@/modules/user/constants/LocaleType';
import { EmbedUrlIndentifier } from '@/modules/embedurl/constants/EmbedUrlIndentifier';
import { EmbedUrlType } from '@/modules/embedurl/constants/EmbedUrlType';

export class EmbedUrl extends BaseEntityModel {
  id?: number;
  jurisdictionId?: number;
  countryId?: number;
  identifier?: EmbedUrlIndentifier;
  locale?: LocaleType;
  type?: EmbedUrlType;
  value?: string;

  constructor(model: Partial<EmbedUrl> = {}) {
    super(model);

    this.id = model.id;
    this.jurisdictionId = model.jurisdictionId;
    this.countryId = model.countryId;
    this.identifier = model.identifier;
    this.locale = model.locale;
    this.type = model.type;
    this.value = model.value;
  }
}
